import React from 'react';
import { Category } from '../../../utils/api/category/category.type';
import { getImage } from '../../../utils/Utils';
import Empty from "../../../assets/images/icons/icon2.svg";
import SubCategoriesModal from './SubCategoriesModal';
import ProductsModal from './ProductsModal';


export const CategoryCard = ({ category }: { category: Category }) => {
    const [show, setShow] = React.useState<boolean>(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    return (
        <>
            <div
                className="category-card"
                role="button"
                onClick={handleShow}
            >
                <div className="cover-wrapper">
                    <img
                        src={category?.images ? getImage(category?.images) : Empty}
                        alt="cover"
                    />
                </div>
                <h5 className="title-category-product-item-mobile">
                    {category?.nom}
                </h5>
            </div>
            <SubCategoriesModal
                show={show}
                handleClose={handleClose}
                category={category}
            />
        </>
    )
}


export const SubCategoryCard = (
    { category, subCategory }:
        { category: Category, subCategory: Category }
) => {
    const [show, setShow] = React.useState<boolean>(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    return (
        <>
            <div
                className="category-card"
                role="button"
                onClick={handleShow}
            >
                <div className="cover-wrapper">
                    <img
                        src={subCategory?.images ? getImage(subCategory?.images) : Empty}
                        alt="cover"
                    />
                </div>
                <h5 className="title-category-product-item-mobile">
                    {subCategory?.nom}
                </h5>
            </div>
            <ProductsModal
                show={show}
                handleClose={handleClose}
                subCategory={subCategory}
            />
        </>
    )
}